import classNames from 'classnames';

function Graphic(props) {
    const { className, position, type, ...rest } = props;

    // return
    const css = classNames('lds-graphic2', className, type && `is-type-${type}`, `is-${position}`);
    return <div className={css} {...rest}></div>;
}

export default Graphic;